module.exports = __webpack_public_path__ + "resources/img/logo_toastbill_color.ed59b0a39fa2da2cfe7e6182e384d895.png";